// /src/components/SingleTabBlock.jsx
import React from "react";

const SingleTabBlock = () => {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontFamily: "sans-serif",
      textAlign: "center"
    }}>
      <h2>⚠️ This application is already open in another tab.<br />
      Please use a single tab only.</h2>
    </div>
  );
};

export default SingleTabBlock;
